import { StrictMode } from 'react'
import { hydrateRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Hydrate the prerendered markup (reuses the server DOM instead of wiping it,
// which gives Lighthouse a stable LCP element).
hydrateRoot(
  document.getElementById('root'),
  <StrictMode>
    <App />
  </StrictMode>,
)
